import { useState, useEffect } from 'react';
import { STATUS_ORDER, STATUS_LABELS } from '@launchpad/shared';
import { ApplicationCard } from './ApplicationCard.jsx';

const STATUS_COLORS = {
  saved: 'bg-status-saved',
  applied: 'bg-status-applied',
  interviewing: 'bg-status-interviewing',
  offer: 'bg-status-offer',
  rejected: 'bg-status-rejected',
  target: 'bg-slate-400',
  researched: 'bg-blue-400',
  outreach: 'bg-amber-400',
  scheduled: 'bg-emerald-400',
  nurturing: 'bg-purple-400',
};

export function MobileBoard({ applications, onCardClick, onContextMenu, statusOrder = STATUS_ORDER, statusLabels = STATUS_LABELS }) {
  const [activeStatus, setActiveStatus] = useState(statusOrder[0]);

  useEffect(() => {
    if (!statusOrder.includes(activeStatus)) setActiveStatus(statusOrder[0]);
  }, [statusOrder]);

  const cards = applications
    .filter((a) => a.status === activeStatus)
    .sort((a, b) => a.columnOrder - b.columnOrder);

  return (
    <div className="flex h-full flex-col">
      {/* Status tabs */}
      <div className="flex overflow-x-auto border-b border-slate-200 bg-slate-50 px-2" role="tablist">
        {statusOrder.map((status) => {
          const count = applications.filter((a) => a.status === status).length;
          const isActive = status === activeStatus;
          return (
            <button
              key={status}
              role="tab"
              aria-selected={isActive}
              onClick={() => setActiveStatus(status)}
              className={`flex shrink-0 items-center gap-1.5 px-3 py-2.5 text-xs font-medium border-b-2 transition-colors ${
                isActive
                  ? 'border-primary-600 text-primary-700'
                  : 'border-transparent text-slate-500'
              }`}
            >
              <span className={`size-2 rounded-full ${STATUS_COLORS[status] || 'bg-slate-300'}`} />
              {statusLabels[status] || status}
              <span className="text-[10px] text-slate-400">{count}</span>
            </button>
          );
        })}
      </div>

      {/* Cards */}
      <div className="flex-1 overflow-y-auto p-3 space-y-2">
        {cards.length === 0 ? (
          <p className="text-center text-sm text-slate-400 py-8">No applications in {statusLabels[activeStatus] || activeStatus}</p>
        ) : (
          cards.map((app) => (
            <ApplicationCard key={app.appId} app={app} onClick={onCardClick} onContextMenu={onContextMenu} />
          ))
        )}
      </div>
    </div>
  );
}
